import { OptionType, ReportsApprovalTypes } from '../../../../types/ReportsApproval'

export enum ReportsApprovalColumns {
    ID = 'ID',
    REPORT_NAME = 'Report Name',
    SCHEDULE_NAME = 'Schedule Name',
    ALARM_RULE = 'Alarm Rule',
    ASSET = 'Asset',
    TIMESPAN = 'Timespan',
    DATA_STATUS = 'Data Status',
    SENDING_STATUS = 'Sending Status'
}

export interface SortOption {
    field: ReportsApprovalColumns
    reverse: boolean
}

export interface FilterOption {
    columnName: ReportsApprovalColumns
    options: OptionType<string>[]
}

export function handleSorterReportsApprovalList(
    reportA: ReportsApprovalTypes,
    reportB: ReportsApprovalTypes,
    sorter: SortOption
): number {
    if (sorter !== undefined) {
        const ra = !sorter.reverse ? reportA : reportB
        const rb = !sorter.reverse ? reportB : reportA
        switch (sorter.field) {
            case ReportsApprovalColumns.ID:
                return ra?.id - rb?.id
            case ReportsApprovalColumns.REPORT_NAME:
                return ra?.reportname?.localeCompare(rb?.reportname)
            case ReportsApprovalColumns.SCHEDULE_NAME:
                return ra?.schedulename?.localeCompare(rb?.schedulename)
            case ReportsApprovalColumns.ALARM_RULE:
                return ra?.alarmname?.localeCompare(rb?.alarmname)
            case ReportsApprovalColumns.ASSET:
                return ra?.asset?.localeCompare(rb?.asset)
            case ReportsApprovalColumns.TIMESPAN:
                // return ra.timespan - rb.timespan
                return ra?.timespan?.localeCompare(rb?.timespan)
            case ReportsApprovalColumns.DATA_STATUS:
                const dataStatusA = ra.usernamecheckdata ? ra.usernamecheckdata : 'Unchecked'
                const dataStatusB = rb.usernamecheckdata ? rb.usernamecheckdata : 'Unchecked'
                return dataStatusA.localeCompare(dataStatusB)
            case ReportsApprovalColumns.SENDING_STATUS:
                const sendingStatusA = ra.usernamesenddata ? ra.usernamesenddata : 'No sent'
                const sendingStatusB = rb.usernamesenddata ? rb.usernamesenddata : 'No sent'
                return sendingStatusA.localeCompare(sendingStatusB)
            default:
                return 0
        }
    }

    return 0
}

export const handleChangeSorter = (columnName: ReportsApprovalColumns, selectedSorter, setSelectedSorter) => {
    if (selectedSorter?.field === columnName) setSelectedSorter({ ...selectedSorter, reverse: !selectedSorter.reverse })
    else setSelectedSorter({ field: columnName, reverse: true })
}
